import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';

import { DtoSystemMessage } from '../../models/notifications.model';
import { SystemMessagesService } from './system-messages.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { PageEvent } from '@angular/material/paginator';
import { CommentDialogComponent } from '../../shared/components/comment-dialog/comment-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PageKey } from '../../const';
import { SearchService } from '../common/search.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-system-messages',
  templateUrl: './system-messages.component.html',
  styleUrl: './system-messages.component.scss'
})
export class SystemMessagesComponent {
  @ViewChild('systemMessageEditForm', { static: true }) systemMessageEditFormDialog!: TemplateRef<any>;
  systemMessages: DtoSystemMessage[] = [];
  pageSize: number = 10;
  pageNumber: number = 0;
  pageOffSet: number = 0;
  totalRecords: number | undefined;
  searchTerm: string = "";
  pageKey = PageKey.TraceReportCenter;
  sortNameAsc: boolean = true;
  sortReportNameAsc: boolean = true;
  sortColumn: string = "";
  sortDirection: string = "";
  searchBy: string = "Search by Message";

  @Input() showForm: boolean = false;
  @Output() close = new EventEmitter<void>();
  isEdit: boolean = false;
  isReadOnly:boolean = false;
  systemMessageToEdit: DtoSystemMessage = {} as DtoSystemMessage;
  systemMessageEditFormRef: MatDialogRef<any> | undefined;

  systemMessageForm: FormGroup = new FormGroup({
    clientReference: new FormControl([], [
    ]),
    holdingFromDate: new FormControl([], [
      // Validators.pattern("dddd-dd-dd")
    ]),
    validFrom: new FormControl([], [
      // Validators.pattern("dddd-dd-dd")
    ]),
    validTo: new FormControl([], [
      // Validators.pattern("dddd-dd-dd")
    ]),
    message: new FormControl([], [
      Validators.required
    ])
  });

  constructor(
    private systemMessagesService: SystemMessagesService,
    private toasterService: ToastrService,
    public dialog: MatDialog,
    private readonly searchService: SearchService,
    private snackBar: MatSnackBar
  ) { }


  ngOnInit(): void {
    this.searchTerm = this.searchService.getSearchTerm(this.pageKey);
    this.getAllLogs();
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.getAllLogs();
  }


  closeCreateForm() {
    this.systemMessageForm.reset();
    this.showForm = false;
    this.close.emit();
    this.dialog.closeAll();
  }

  viewExceptionModal(description: string) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: description
    });
  }

  getAllLogs(sortColumn = "", sortDirection = "") {
    this.searchService.setSearchTerm(this.pageKey, this.searchTerm);
    if (sortColumn) {
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
    payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
    payload.sortDirection = this.sortDirection;
    payload.pageOffset = this.pageOffSet;
    payload.pageSize = this.pageSize;
    payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";

    this.systemMessagesService.getMessages(payload)
      .subscribe({
        next: (response: any) => {
          this.totalRecords = response?.length ? parseInt(response[0].totalRecords, 10) : 0;
          this.systemMessages = response;
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, "Error");
          }
          else {
            //this.toasterService.error(err.message, "Error");
            this.toasterService.error("There has been an error processing your request.", "Error - " + err.statusText);
          }

        }
      });
  }

  initShowForm(systemMessageDetails: DtoSystemMessage){
    this.systemMessageForm.patchValue(systemMessageDetails);
    this.showForm = true;
    this.systemMessageToEdit = systemMessageDetails;

    this.systemMessageEditFormRef = this.dialog.open(
      this.systemMessageEditFormDialog, {
      width: '400px'
    });
  }

  showDeleteMessage(systemMessageDetails: DtoSystemMessage) {
    this.isEdit = false;
    this.isReadOnly = true;
    this.initShowForm(systemMessageDetails);
  }

  deleteMessage(messageId: number){
  this.systemMessagesService.deleteMessage(messageId).subscribe({
        next: () => {
          this.toasterService.success(
            'System Message delete successfully',
            'Success'
          );
          this.getAllLogs();
        this.closeCreateForm();
      },
      error: (error) => {
        if (error.error) {
          this.toasterService.error(error.error, 'Error');
        }
      }
    });
  }

  saveMessage() {
    let formValue = JSON.parse(JSON.stringify(this.systemMessageForm.value)) as any;

    Object.keys(formValue).forEach(key => {
      if (formValue[key as keyof DtoSystemMessage] === '') {
        formValue[key as keyof DtoSystemMessage] = null as never;
      }
    });

    let systemMessageDetail: DtoSystemMessage = formValue as DtoSystemMessage;

    systemMessageDetail.systemMessageId = this.systemMessageToEdit.systemMessageId;


    this.systemMessagesService.updateMessage(systemMessageDetail).subscribe({
      next: () => {
        this.toasterService.success(
          'System Message updated successfully',
          'Success'
        );
        this.getAllLogs();
        this.closeCreateForm();
      },
      error: (error) => {
        if (error.error) {
          this.toasterService.error(error.error, 'Error');
        }
      }
    });
  }

  preview_massage(msg: string) {
    this.systemMessagesService.preview_message(msg)
      .subscribe(
        {
          next: (preview: string) => {
            this.snackBar.open(preview,
              'Dismiss',
              {
                duration: 0,
                panelClass: ['alert-snackbar'],
                horizontalPosition: 'center'
              });
          },
          error: (err: HttpErrorResponse) => {
            if (err.error) {
              this.toasterService.error(err.error, "Error");
            }
            else {
              //this.toasterService.error(err.message, "Error");
              this.toasterService.error("There has been an error processing your request.", "Error - " + err.statusText);
            }
          }
        }
      )

  }


  openCreateMessage() {
    this.isEdit = false;
    this.isReadOnly = false;
    const systemMessageDetails = {
      systemMessageId: 0,
      clientReference: null,
      validFrom: null,
      validTo: null,
      message: null,
      holdingFromDate: null,
      isInHolding: false,
      isActive: false
    } as DtoSystemMessage;

    this.initShowForm(systemMessageDetails);
  }

  patchForm(systemMessageDetails: DtoSystemMessage) {

    this.isEdit = true;
    this.isReadOnly = false;
    this.initShowForm(systemMessageDetails);
  }
}
